import {
  LegalClientEntity,
  LegalClientFirstHeadEntity,
} from 'api/types/entity';
import { useLockLegalClient } from 'modules/client/legal/hooks/useLockLegalClient';

export const useLockLegalClientFirstHead = (
  legalClient: LegalClientEntity | null,
  head: LegalClientFirstHeadEntity | null
) => {
  const { lockClientIfPossible, unlockClient } = useLockLegalClient(
    legalClient
      ? {
          ...legalClient,
          versionNumber: head?.versionNumber,
        }
      : null
  );

  return { lockClientIfPossible, unlockClient };
};
